import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';

const initialState = {
  error: null,
  data: [],
  addData: {},
};

const slice = createSlice({
  name: 'RecruitmentJobRoles',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getJobRolesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateJobRoles(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },
  },
});

export default slice.reducer;

export function getJobRoles() {
  return async () => {
    try {
      const response = await get('recruitment/jobRoles');
      if (response.status) {
        dispatch(slice.actions.getJobRolesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function addJobRole(body) {
  return async () => {
    try {
      const response = await post('recruitment/jobRoles', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateJobRoles(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateJobRole(body) {
  return async () => {
    try {
      const response = await put('recruitment/jobRoles', body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateJobRoles(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
